import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { LazyLoadEvent } from 'primeng/api';
import { ModelWizard } from '../../domain/eurocode';

@Component({
  selector: 'app-admin-models',
  templateUrl: './admin-models.component.html',
  styleUrls: ['./admin-models.component.scss']
})
export class AdminModelsComponent  {
  virtualModels: ModelWizard[] = [];
  totalRecords: number = 0;
  loading: boolean = true;
  rows: number = 10;

  constructor(private adminService: AdminService, private router: Router) {}

  // ngOnInit(): void {
  //   const storedQuery = localStorage.getItem('modelQuery');
  //   const storedQueryDate = localStorage.getItem('modelQueryDate');
  //   if (storedQuery && storedQueryDate) {
  //     const queryDate = new Date(storedQueryDate);
  //     const now = new Date();
  //     const diffInHours = (now.getTime() - queryDate.getTime()) / (1000 * 60 * 60);
  //     if (diffInHours < 2) {
  //       this.query = storedQuery;
  //     }
  //   }
  //   //this.loadModels({ first: 0, rows: this.rows });
  // }

  // set query(value: string) {
  //   this._query = value;
  //   localStorage.setItem('modelQuery', value);
  //   localStorage.setItem('modelQueryDate', new Date().toISOString());
  // }

  // get query(): string {
  //   return this._query;
  // }
  // private _query: string = '';

  // loadModels(event: LazyLoadEvent): void {
  //   this.loading = true;
  //   const page = 1 + (event.first! / event.rows!);
  //   const size = event.rows!;

  //   this.adminService.getModelsPaged(page, size, this.query).subscribe(
  //     response => {
  //       this.virtualModels = response.Data;
  //       this.totalRecords = response.TotalRecords;
  //       this.loading = false;
  //     },
  //     error => {
  //       console.error('Error fetching models', error);
  //       this.loading = false;
  //     }
  //   );
  // }

  // goBack() {
  //   this.router.navigate(['admin-dashboard']);
  // }

  // edit(item: ModelWizard): void {
  //   this.router.navigate(['admin-models', item.ModId]);
  // }

  // delete(item: ModelWizard): void {
  //   // Implement delete logic here
  // }

  // createNewModel(): void {
  //   this.router.navigate(['admin-models/new']);
  // }
}
